const updateServiceTypes = {
  toastr: 'Updated Service Type',
  toastr1: ' has been updated successfully',
  toastrError: 'Service Type already registered',
  toastrError1: 'Enter another name'
};

export default updateServiceTypes;
